import InputSearch from './InputSearch.view';

export default InputSearch;
